import Dashboard from 'pages/Dashboard';
import Manager from 'pages/Manager';
import Type from 'pages/Type';
import User from 'pages/User';
import React from 'react';
import CleanUp from './pages/CleanUp';
import Feed from './pages/Feed';
import Notification from './pages/Notification';
import Report from './pages/Report';
import Setting from './pages/Setting';
import SystemLog from './pages/SystemLog';
import VipCode from './pages/VipCode';

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: 'far fa-chart-bar',
    component: <Dashboard />,
    layout: '/admin',
  },
  {
    path: '/user',
    name: 'User',
    icon: 'fas fa-user',
    component: <User />,
    layout: '/admin',
  },
  {
    path: '/type',
    name: 'Type',
    icon: 'fas fa-list-ul',
    component: <Type />,
    layout: '/admin',
  },
  {
    path: '/beam',
    name: 'Beam',
    icon: 'fas fa-bolt',
    component: <Dashboard />,
    layout: '/admin',
  },
  {
    path: '/manager',
    name: 'Manager',
    icon: 'fas fa-user-cog',
    component: <Manager />,
    layout: '/admin',
  },
  {
    path: '/system-log',
    name: 'System Log',
    icon: 'fas fa-database',
    component: <SystemLog />,
    layout: '/admin',
  },
  {
    path: '/setting',
    name: 'Setting',
    icon: 'fas fa-cog',
    component: <Setting />,
    layout: '/admin',
  },
  {
    path: '/notification',
    name: 'Notification',
    icon: 'fas fa-bell',
    component: <Notification />,
    layout: '/notification',
  },
  {
    path: '/report',
    name: 'Report',
    icon: 'fas fa-file-alt',
    component: <Report />,
    layout: '/admin',
  },
  {
    path: '/feed',
    name: 'Feed',
    icon: 'fas fa-rss',
    component: <Feed />,
    layout: '/admin',
  },
  {
    path: '/vip-code',
    name: 'VIP Code',
    icon: 'fas fa-crown',
    component: <VipCode />,
    layout: '/admin',
  },
  {
    path: '/clean-up',
    name: 'Clean Up',
    icon: 'fas fa-broom',
    component: <CleanUp />,
    layout: '/admin',
  },
];

export default routes;
